export {LogoCloud} from './lib/logo-cloud';